<script setup lang="ts">
import i18n from '@/lang/i18n';
import RegisterModal from "@/components/Common/RegisterModal.vue";
import { computed } from "vue";
import { UNEXPECTED_EVENT_KEY, SPECIAL_EXTENSION_KEY } from "@/services/consts";

const emits = defineEmits(['update:modelValue', 'cancel', 'openModal'])

const props = defineProps<{
  modelValue: boolean,
}>()

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits('update:modelValue', value);
  },
})

function openModal(key: string) {
  emits('openModal', key)
}
</script>
<template>
  <RegisterModal
    v-model="modelValue"
    modalMaxWidth="30%"
  >
    <template v-slot:content>
      <div
        class="my-5 align-center"
      >
        <div>
          <v-btn
            variant="text"
            class="w-100 d-flex justify-content-start px-2"
            @click="openModal(UNEXPECTED_EVENT_KEY)"
          >
            <p class="mb-0">
              {{ i18n.global.t('pages.dailyReports.updateModal.registerUnexpectedEvents') }}
            </p>
          </v-btn>
        </div>
        <div>
          <v-btn
            variant="text"
            class="w-100 d-flex justify-content-start px-2 mt-3"
            @click="openModal(SPECIAL_EXTENSION_KEY)"
          >
            <p class="mb-0">
              {{ i18n.global.t('pages.dailyReports.updateModal.registerSpecialExtensionContinuousOperation') }}
            </p>
          </v-btn>
        </div>
      </div>
    </template>
    <template v-slot:buttons>
      <v-btn
        class="ma-2 reset-btn"
        @click="modelValue = false"
      >
        {{ i18n.global.t('common.cancelBtn') }}
      </v-btn>
    </template>
  </RegisterModal>
</template>
